import { Identifier, RaRecord } from 'react-admin';

const tableRowSx = (selectedRowsIds: Identifier[]) => (record: RaRecord) =>
    selectedRowsIds.includes(record?.id)
        ? {
              bgcolor: (theme: any) => theme.palette.action.selected,
          }
        : {};

export default tableRowSx;
